import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Skeleton, styled } from '@ori-ui/mui';
import { memo } from 'react';
import { BREAKPOINT_HORIZONTAL_SIDEPANEL } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MenuItem = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'grid',
    gridTemplateColumns: "".concat(theme.spacing(5), " 1fr"),
    gridTemplateRows: '1fr',
    gap: theme.spacing(0, 1),
    alignItems: 'center',
    width: '100%'
  };
});
var MenuText = styled(Skeleton)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    margin: theme.spacing(2, 2, 2, 6),
    height: '33px'
  };
});
var MenuIcon = styled(Skeleton)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    margin: theme.spacing(2, 2, 2, 3),
    height: theme.spacing(6),
    width: theme.spacing(6)
  };
});
var Logout = styled('div')(function (_ref4) {
  var theme = _ref4.theme;
  return {
    position: 'absolute',
    zIndex: 999,
    paddingBottom: theme.spacing(3),
    background: '#f0f3f0',
    display: 'grid',
    gridTemplateColumns: "".concat(theme.spacing(5), " 1fr"),
    gridTemplateRows: '1fr',
    alignItems: 'center',
    width: '100%',
    bottom: 0
  };
});
var Root = styled('div')(function (_ref5) {
  var theme = _ref5.theme;
  return _defineProperty({
    display: 'block',
    position: 'relative',
    top: 0,
    right: 0,
    left: 0,
    boxSizing: 'border-box',
    width: '100%',
    minWidth: theme.spacing(56),
    height: '100vh',
    maxHeight: "calc(100vh - ".concat(theme.spacing(10), ")"),
    overflow: 'hidden',
    backfaceVisibility: 'hidden',
    background: theme.palette.common.white,
    '--scrollbar-minlength': theme.spacing(2),
    '--scrollbar-ff-width': 'thin',
    marginTop: theme.spacing(3)
  }, theme.breakpoints.up(BREAKPOINT_HORIZONTAL_SIDEPANEL), {
    position: 'fixed',
    zIndex: 999,
    top: 'var(--top-nav-height)',
    right: 'unset',
    bottom: 0,
    left: 0,
    width: theme.spacing(56),
    maxWidth: theme.spacing(56),
    height: '100%',
    maxHeight: 'calc(100% - var(--top-nav-height))',
    transition: 'unset',
    transitionProperty: 'unset',
    boxShadow: theme.shadows[2]
  });
});
export var SkeletonLoader = /*#__PURE__*/memo(function () {
  return /*#__PURE__*/_jsxs(Root, {
    children: [Array.from({
      length: 6
    }, function (_, key) {
      return /*#__PURE__*/_jsxs(MenuItem, {
        children: [/*#__PURE__*/_jsx(MenuIcon, {
          animation: "wave",
          variant: "rectangular"
        }), /*#__PURE__*/_jsx(MenuText, {
          animation: "wave",
          variant: "text"
        })]
      }, "point-".concat(key));
    }), /*#__PURE__*/_jsxs(Logout, {
      children: [/*#__PURE__*/_jsx(MenuIcon, {
        animation: "wave",
        variant: "rectangular"
      }), /*#__PURE__*/_jsx(MenuText, {
        animation: "wave",
        variant: "text"
      })]
    })]
  });
});